module.exports = __webpack_public_path__ + "img/Icon - Wrong Answer.2acd0e3d.svg";